import { Input } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledInput = styled(Input)`
  input {
    width: 4rem;
  }
`
